<template>
    <div>
        <h1>End-User License Agreement (EULA)</h1>

        Effective Date: 2025 January 22
        Last Updated: 2025 Januar 22

        This End-User License Agreement ("Agreement") governs the use of the private application ("Application") developed by X PLUS Company Ltd. and utilized exclusively by X PLUS North America Corp. ("Company") and X PLUS Company Ltd. By accessing or using the Application, the Company agrees to the terms of this Agreement.
        
        <h2>1. Purpose</h2>
        The Application is strictly for internal use by X PLUS North America Corp. and X PLUS Company Ltd. It is not intended for use by third parties, customers, or any other external entities.
        
        <h2>2. License</h2>
        The Company retains full ownership of the Application and grants itself a non-transferable, non-sublicensable, and non-exclusive right to use the Application solely for internal operations.
        
        <h2>3. Scope of Use</h2>
        <ul>
            <li>The Application is used solely by employees of X PLUS North America Corp. and X PLUS Company Ltd.</li>
            <li>No external parties, including customers, clients, or partners, shall have access to or be affected by the Application.</li>
        </ul>

        <h2>4. Data and Privacy</h2>
        The Application processes and stores data exclusively for internal business purposes.
        
        <h2>5. Liability</h2>
        X PLUS North America Corp. assumes all responsibilities for the use of this Application within its organization. This Agreement does not create liabilities for external entities.
        
        <h2>6. Amendments</h2>
        This Agreement may be updated from time to time, solely at the discretion of X PLUS North America Corp., to reflect changes in internal policies or operational needs.
    </div>
</template>

<script>
export default{
    mounted(){
        this.$nextTick(()=>{
            const navbar = document.getElementById('Navigationbar');
            if (navbar !== null)
            {
                navbar.remove();
            }
        });
    }
}
</script>